import React from "react";
import "./SaveSectionAbout.css";
import Savesection from "../../assets/Savesection.png";
import { Link } from "react-router-dom";

const SaveSection = () => {
  return (
    <section className="save-section-about">
      <p className="save-section-subtitle-about">A WORLD WIDE DISTRIBUTOR OF SOLAR SUPPLIES</p>
      <h2 className="save-section-title-about">☀️ CM Green Energy India Private Limited: About Us</h2>

      <div className="save-section-content-about">
        {/* LEFT TEXT BLOCK */}
        <div className="save-section-text-about">
          <h3>We are building a sustainable absolute green future.</h3>
          <p>
            Powering India’s transition to a sustainable future. 
            We deliver high-performance, reliable solar systems 
            that drastically reduce energy costs and environmental 
            footprint for homes, businesses, and industries nationwide.
            Join the movement to energy independence.
          </p>

          <Link to="/green-energy/services" className="save-section-btn-about">
  View services →
</Link>
        </div>

        {/* IMAGE BLOCK */}
        <div className="save-section-image-wrapper-about">
          <img
            src={Savesection}
            alt="Solar panels"
            className="save-section-image-about"
          />
          <div className="save-section-badge-about"><span style={{ fontSize: "25px", fontWeight: "700",}}>50%</span>
  Renewable energy growth</div>
        </div>

        {/* RIGHT SIDE STATS */}
        <div className="save-section-stats-about">
          <p>Part of: CM Group of Companies</p>
          <p>Group Affiliation: We are a part of the Speed Team Group of Companies.</p>
          <p>Group Establishment: The Speed Team Group of Companies was established in 2019.</p>
        </div>
      </div>

      {/* BIG BACKGROUND TEXT */}
      <h1 className="background-text-about">CMGreen energy</h1>
    </section>
  );
};

export default SaveSection;
